module.exports = __webpack_public_path__ + "dedcb1f2be5adb3ed9c30ec66b868381.jpg";